import React, { Component } from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { CS_INQUIRY_PAGE_NAME } from '../../../constants/service/app/csInquiryConstants';
import CsInquiryListWrap from '../../../views/cs/inquiry/list/CsInquiryListWrap';

class CsInquiryList extends Component {
  render() {
    return (
      <PageTemplate pageName={CS_INQUIRY_PAGE_NAME.INQUIRY_LIST}>
        <CsInquiryListWrap />
      </PageTemplate>
    );
  }
}

export default CsInquiryList;
